$ = require('jquery');

/**
 * For all AJAX requests that are not GET or POST set the method to POST and add a _METHOD query
 * parameter which indicates the HTTP method
 */
$.tyndaleAjax = function(args) {
  if ( args.method && 'GET' !== args.method ) {
    args.data = args.data || {};
    args.data = $.extend(args.data, {
      _METHOD: args.method
    });
    args.method = 'POST';
  }

  return $.ajax(args);
};

/**
 * Add blur functions
 * @param  object     options     options including type and callback
 * @return object                 JQuery object
 */
$.fn.validateValue = function(options) {
  options = options || {};
  return this.on('blur', validateValue.bind(null, options));
};

function validateValue(options, event) {
  var element = event.target;
  var $el = $(element);
  if ( element.value === $el.data('oldValue') ) return;

  var type = options.type;

  if ( !type ) {
    if ('password' === element.type) {
      type = 'password';
    } else if ('tel' === element.type) {
      type = 'phone';
    } else if ('zip' === element.name) {
      type = 'zipcode';
    } else if ('email' === element.type) {
      type = 'email';
    } else if ('date' === element.type) {
      type = 'date';
    } else {
      return;
    }
  }

  $.tyndaleAjax({
    url: '/check/' + type,
    dataType: 'json',
    success: function(data) {
      $el.data('isValid', true === data.status);
      $el.data('oldValue', element.value);

      if ( options.$error && options.$error.length ) {
        if ( true === data.status ) {
          options.$error.text('');
        } else {
          options.$error.text(data.status);
        }
      }

      if ( 'function' === typeof callback ) {
        callback.call(element, data.status);
      }
    },
    data: {
      value: element.value
    }
  });
}

module.exports = $;



//////////////////
// WEBPACK FOOTER
// ./views/js/jquery.js
// module id = 4
// module chunks = 2 3 4